import { useSyncExternalStore } from 'react';
import {
  checkFeatureFlag,
  FeatureFlag,
  subscribeToBetaFeatures,
} from 'hooks/useFeatureFlag';

const getDarkModeEnabled = () => checkFeatureFlag(FeatureFlag.ENABLE_DARK_MODE);

// Reads the flag without `useLocation`, so it works above the router.
const useDarkModeEnabled = () =>
  useSyncExternalStore(subscribeToBetaFeatures, getDarkModeEnabled);

export default useDarkModeEnabled;
